import { useRouter } from "next/router";

import { useSearchContext } from "@/features/search/context/SearchContext";
import { getVisibleFacets } from "@/features/search/utils/facets.utils";
import { isUsLocale } from "@/i18n/config";

/** The current response's facets worth rendering, for this locale (see `getVisibleFacets`). */
export const useVisibleFacets = () => {
  const { locale } = useRouter();
  const { query } = useSearchContext();

  return getVisibleFacets(query.data?.facets ?? [], isUsLocale(locale));
};
